import * as THREE from 'three';
import { boom, thud } from './audio';
import { _tmp, cyl, placeBeam, raycaster } from './beam';
import { addDollars } from './combo';
import { toast, ui } from './hud';
import { smoke, sparks } from './particles';
import { camera, rig, scene } from './scene';
import { S } from './state';
import { fmt$, rnd } from './util';

export const heliGroup = new THREE.Group(); scene.add(heliGroup);
export function makeHeli(){
  const g = new THREE.Group();
  const bodyM = new THREE.MeshStandardMaterial({color:'#2f3338', roughness:.5, metalness:.6});
  const body = new THREE.Mesh(new THREE.BoxGeometry(9, 3.2, 3.4), bodyM); body.castShadow = true; g.add(body);
  const nose = new THREE.Mesh(new THREE.SphereGeometry(1.8, 10, 8), new THREE.MeshStandardMaterial({color:'#8fb0c8', roughness:.1, metalness:.6})); nose.position.set(4.8,0,0); nose.scale.set(1.2,0.9,1); g.add(nose);
  const tail = new THREE.Mesh(new THREE.BoxGeometry(9, 1.1, 0.9), bodyM); tail.position.set(-8.5, 0.6, 0); g.add(tail);
  const fin = new THREE.Mesh(new THREE.BoxGeometry(1.2, 3.2, 0.5), bodyM); fin.position.set(-12.5, 1.8, 0); g.add(fin);
  const rotor = new THREE.Mesh(new THREE.BoxGeometry(18, 0.18, 0.9), new THREE.MeshStandardMaterial({color:'#111', roughness:.8})); rotor.position.y = 2.2; g.add(rotor);
  const rotor2 = rotor.clone(); rotor2.rotation.y = Math.PI/2; g.add(rotor2);
  const light = new THREE.Mesh(new THREE.SphereGeometry(0.35, 6, 6), new THREE.MeshBasicMaterial({color:new THREE.Color(4,0.4,0.3)})); light.position.set(-12.5, 3.6, 0); g.add(light);
  g.userData = {rotors:[rotor, rotor2], blink:light};
  return g;
}
export const tracer = new THREE.Mesh(cyl, new THREE.MeshBasicMaterial({color:new THREE.Color(3,2.4,1.2), fog:false})); tracer.visible = false; scene.add(tracer);
export let tracerT = 0;
export function spawnHeli(){
  const g = makeHeli(); heliGroup.add(g);
  const ang = Math.random()*Math.PI*2;
  S.helis.push({g, ang, r:rnd(180,260), alt:rig.h+rnd(20,60), hp:1, w:rnd(0.25,0.4)*(Math.random()<.5?1:-1), shootT:rnd(2,4), hitT:0});
}
export function heliExplode(h, i){
  const p = h.g.position;
  for (let k=0;k<60;k++) sparks.emit(p, new THREE.Vector3(0,6,0), 40, 1.2);
  for (let k=0;k<30;k++) smoke.emit(p, new THREE.Vector3(0,3,0), 10, 4);
  boom(0.6); rig.shake += 1.2;
  heliGroup.remove(h.g); S.helis.splice(i,1); S.heliKills++;
  S.juice = Math.min(100, S.juice + 35); S.dry = false;
  const bounty = 8e6; addDollars(bounty, p, true); toast('Helicopter down', '+35 juice · ' + fmt$(bounty));
}
export function updateHelis(dt, now){
  // escalate with damage done
  const want = (S.mode==='roam' || S.mode==='world') ? 0 : Math.min(3, Math.floor(S.dollars / Math.max(S.totalValue*0.07, 1)));
  if (S.helis.length < want && Math.random() < dt*0.5) spawnHeli();
  for (let i=S.helis.length-1;i>=0;i--){
    const h = S.helis[i]; h.ang += h.w*dt;
    const tx = rig.base.x + Math.cos(h.ang)*h.r, tz = rig.base.z + Math.sin(h.ang)*h.r;
    h.g.position.lerp(_tmp.set(tx, h.alt + Math.sin(now/700+i)*4, tz), 1-Math.exp(-dt*1.5));
    h.g.lookAt(rig.base.x + Math.cos(h.ang+h.w*0.6)*h.r, h.g.position.y, rig.base.z + Math.sin(h.ang+h.w*0.6)*h.r); h.g.rotateY(-Math.PI/2);
    for (const r of h.g.userData.rotors) r.rotation.y += dt*40;
    h.g.userData.blink.visible = Math.floor(now/400)%2===0;
    // beam hit test: distance from aim ray to heli
    if (S.firing){ const d = raycaster.ray.distanceToPoint(h.g.position); if (d < 9 + 10*S.width){ h.hp -= dt*(1.2 + 1.5*S.width); h.hitT = now; for (let k=0;k<2;k++) sparks.emit(h.g.position, new THREE.Vector3(0,4,0), 14, 0.4); if (h.hp <= 0){ heliExplode(h, i); continue; } } }
    // shooting
    h.shootT -= dt;
    if (h.shootT <= 0){ h.shootT = rnd(2.2, 4.2);
      const from = h.g.position, to = camera.position;
      placeBeam(tracer, tracer, from, _tmp.copy(to).add(new THREE.Vector3(rnd(-3,3), rnd(-3,3), rnd(-3,3))), 0.35); tracer.visible = true; tracerT = 0.12;
      if (S.shieldT > 0){ toast('Shield held'); thud(0.3); } else { S.juice = Math.max(0, S.juice - 7); rig.shake += 0.9; ui.hit.style.opacity = 0.9; thud(0.8); toast('Under fire', '-7 juice'); } }
  }
  tracerT -= dt; if (tracerT <= 0) tracer.visible = false;
}

